import { createReducer, on } from '@ngrx/store';
import { ScatterPlotPlotType } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { setEndDate } from './end-date.actions';
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
export const endDate = createReducer(null, on(setEndDate, (state, { date }) => {
    return date;
}), on(setScatterPlot, (state, action) => {
    if (action.scatterPlot.plotType === ScatterPlotPlotType.timeseries) {
        return action.scatterPlot.endDate;
    }
    return state;
}));
